import React from "react";

// eslint-disable-next-line no-unused-vars
function SimpleButton({ className, title, disabled, callback }) {
  return (
    <>
      <button onClick={callback} className={`${className} py-3 px-8`}>
        {title}
      </button>
    </>
  );
}

export default SimpleButton;